import { combineEpics, ActionsObservable, StateObservable, ofType } from 'redux-observable';
import { RootAction, RootState } from '@src/app/_redux';
import { ApiClient } from '@src/app/_global/utility/apiUtils';
import { ApiConfig } from '@src/app/_global/domain';
import { map, mergeMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { concat } from 'rxjs/observable/concat';
import { fromPromise } from 'rxjs/observable/fromPromise';
import { actionCreators, RESIN_ORDER_START, RESIN_SPECULATIVE_START } from '@src/app/accounts/resin-order/actions';
import { actionCreators as gaActionCreators } from '@src/app/analytics/googleAnalytics/actions';
import { actionCreators as weakActionCreators } from '@src/app/login/weak/actions';
import { delay } from 'rxjs/operators';
import {
  config as AWSConfig,
  CognitoIdentityCredentials,
} from 'aws-sdk/global';

var AWS = require('aws-sdk');

const amendmentOrder = (
  action$: ActionsObservable<RootAction>,
  state$: StateObservable<RootState>,
) =>
  action$.pipe(
    ofType(RESIN_ORDER_START),
    mergeMap(({ payload }) => {
      const clientConfig = state$.value.clientConfig.clientConfig;
      AWS.config.region = clientConfig.Region;
      const loading = of(actionCreators.resinOrderLoading(true));
      if (!AWS.config.credentials) {
        const creds = state$.value.auth.omsAuth.credentials;
        AWS.config.credentials = new AWS.CognitoIdentityCredentials(creds);
      }

      const apiConfig: ApiConfig = {
        creds: AWSConfig.credentials as CognitoIdentityCredentials,
        url: clientConfig.url,
        path: '/order',
        region: clientConfig.Region,
        requestmethod: 'POST',
        requestbody: payload,
        parms: {},
        additionalParms: {
          headers: {
            'x-session-id': clientConfig.uuid
          },
        },
      };

      const client = new ApiClient();
      const $source = fromPromise(client.callApiGateway(apiConfig)).pipe(
        map(answer => {
          const isSuccess = String(answer.success) === 'true';
          if (isSuccess) {
            gaActionCreators.createGAEvent({
              category: payload.googleAnalyticsCategory,
              action: 'Successful',
              label: payload.prodIdAlias,
            });
            let newResponse = {...answer, payload};
            return actionCreators.resinOrderSuccess(newResponse);
          } else {
            gaActionCreators.createGAEvent({
              category: payload.googleAnalyticsCategory,
              action: 'Unsuccessful',
              label: payload.prodIdAlias,
            });
            return actionCreators.resinOrderError(answer);
          }
        }),
        catchError(err => {
          gaActionCreators.createGAEvent({
            category: payload.googleAnalyticsCategory,
            action: 'Unknown Error',
            label: payload.prodIdAlias,
          });
          return of(
            actionCreators.resinOrderError({
              success: false,
              message: err,
            }),
          );
        }),
      );
      
      const refetchCustomerPayload = {
        accountNumber: payload.accountNumber,
        postalCode: payload.postalCode,
      };
      let reloadCust = of(weakActionCreators.refetchCustomer(refetchCustomerPayload));
      return concat(loading, $source, reloadCust.pipe(delay(2000)));

    }),
  );

  const speculativeOrder = (
    action$: ActionsObservable<RootAction>,
    state$: StateObservable<RootState>,
  ) =>
    action$.pipe(
      ofType(RESIN_SPECULATIVE_START),
      mergeMap(({ payload }) => {
        const clientConfig = state$.value.clientConfig.clientConfig;
        AWS.config.region = clientConfig.Region;
        const loading = of(actionCreators.resinOrderLoading(true));
        if (!AWS.config.credentials) {
          const creds = state$.value.auth.omsAuth.credentials;
          AWS.config.credentials = new AWS.CognitoIdentityCredentials(creds);
        }
  
        const apiConfig: ApiConfig = {
          creds: AWSConfig.credentials as CognitoIdentityCredentials,
          url: clientConfig.url,
          path: '/order',
          region: clientConfig.Region,
          requestmethod: 'POST',
          requestbody: payload,
          parms: {},
          additionalParms: {
            headers: {
              'x-session-id': clientConfig.uuid
            },
          },
        };
  
        const client = new ApiClient();
        const $source = fromPromise(client.callApiGateway(apiConfig)).pipe(
          map(answer => {
            const isSuccess = String(answer.success) === 'true';
            if (isSuccess) {
              let newResponse = {...answer, payload};
              return actionCreators.resinSpeculativeSuccess(newResponse);
            } else {
              gaActionCreators.createGAEvent({
                category: 'Speculative Order',
                action: 'Unsuccessful',
                label: payload.prodIdAlias,
              });
              return actionCreators.resinSpeculativeError(answer);
            }
          }),
          catchError(err => {
            gaActionCreators.createGAEvent({
              category: 'Speculative Order',
              action: 'Unknown Error',
              label: payload.prodIdAlias,
            });
            return of(
              actionCreators.resinSpeculativeError({
                success: false,
                message: err,
              }),
            );
          }),
        );
        
        return concat(loading, $source);
  
      }),
    );
export const epics = combineEpics(amendmentOrder, speculativeOrder);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/accounts/resin-order/epics.ts